module.exports = __webpack_public_path__ + "img/t6.05cb68a4.png";